import { apiFetch } from "./apiFetch";

export function sendInvite(payload) {
  return apiFetch("/invites/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
